
import { Vue, Options } from "vue-class-component";
import { ListCariSTTController } from "@/app/ui/controllers/ListCariSTTController";
import {
  CLIENT_ERROR,
  INTERNET_ERROR,
  INTERNAL_SERVER_ERROR,
} from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import {
  CariSttEntities,
  CariSttRequest,
  ListCariSTT,
} from "@/domain/entities/ListCariSTT";
import { Pagination } from "@/domain/entities/Pagination";
import debounce from "lodash/debounce";
import Print from "./modules/print.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";

@Options({
  components: {
    Print,
  },
})
class CariSTTList extends Vue {
  isLoadingFetch = false;
  errorState = "";
  cariSTTList: ListCariSTT[] = [];
  pagination = new Pagination(1, 10);
  search = "";
  startDate = "";
  endDate = "";
  params = new CariSttRequest();
  res = new CariSttEntities(this.pagination, this.cariSTTList);

  async getListCariSTT() {
    try {
      this.isLoadingFetch = true;
      this.errorState = "";
       this.res = await ListCariSTTController.getListCariSTT(
        new CariSttRequest({
          page: this.res.pagination.page,
          limit: this.res.pagination.limit,
          search: this.params.search,
          startDate: this.params.startDate,
          endDate: this.params.endDate
        })
       );
      this.cariSTTList = this.res.data;
      this.pagination = this.res.pagination;
    } catch (error) {
      this._handlerError(error);
    } finally {
      this.isLoadingFetch = false;
    }
  }

  // Table
  get columns() {
    return [...this.columns1, ...this.columns2, ...this.columns3];
  }

  get columns1() {
    return [
      {
        name: this.$t("cariStt.columnNo"),
        styleHead: "w-12 text-left",
        render: (_item: ListCariSTT, index: any) => {
          return `<div class="overflow-ellipsis text-left">${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        },
      },
      {
        name: this.$t("cariStt.columnManifestNo"),
        styleHead: "w-32 whitespace-nowrap text-left",
        render: (item: ListCariSTT) => {
          return `<div class="overflow-ellipsis text-left">${item.manifestNo ||
            "-"}</div>`;
        },
      },
      {
        name: this.$t("cariStt.columnTotalStt"),
        styleHead: "w-24 text-left",
        render: (item: ListCariSTT) => {
          return `<div class="overflow-ellipsis text-left">${item.totalStt ||
            "-"}</div>`;
        },
      },
    ];
  }

  get columns2() {
    return [
      {
        name: this.$t("cariStt.columnTotalKoli"),
        styleHead: "w-24 text-left",
        render: (item: ListCariSTT) => {
          return `<div class="overflow-ellipsis text-left">${item.totalPieces ||
            "-"}</div>`;
        },
      },
      {
        name: this.$t("cariStt.columnTotalSttHanging"),
        styleHead: "w-32 text-left",
        render: (item: ListCariSTT) => {
          if (item.totalSttHanging) return `<div class="overflow-ellipsis text-left">${item.totalSttHanging} STT</div>`;
          else return `<div class="overflow-ellipsis text-left">-</div>`;
        },
      },
      {
        name: this.$t("cariStt.columnTanggalManifest"),
        styleHead: "w-44 text-left",
        render: (item: ListCariSTT) => {
          return `<div class="flex flex-col"><div class="overflow-ellipsis text-left">${formatDate(
            item.createdAt || "-"
          )}<div class="overflow-ellipsis text-gray-lp-600 break-all">${item.createdByUsername ||
            "-"}</div></div>`;
        },
      },
    ];
  }

  get columns3() {
    return [
      {
        name: this.$t("cariStt.columnAtur"),
        key: "button_column",
        styleHead: "w-16 text-left",
        styleCustom: "padding-action-sti",
        styleButton: (item: ListCariSTT) => {
          let groupOptions = [] as any[];

          const printManifest = {
            icon: "printer",
            label: this.$t("cariStt.printManifest"),
            clickFunction: () => this.printManifest(item.manifestId),
          };

          const downloadCSV = {
            icon: "download-gray",
            label: this.$t("cariStt.downloadCsv"),
            clickFunction: () => this.downloadManifest(item.manifestId),
          };

          groupOptions = [printManifest, downloadCSV];

          return {
            outline: true,
            icon: "option-gray",
            title: "",
            textColor: "black",
            color: "gray-lp-400",
            clickFunction: () => null,
            groupOptions: groupOptions,
          };
        },
      },
    ];
  }

  _handlerError(error: any) {
    if (!error.response) {
      this.errorState = INTERNET_ERROR;
      return;
    }
    if (error.response.status > 500) {
      this.errorState = CLIENT_ERROR;
      return;
    }
    this.errorState = INTERNAL_SERVER_ERROR;
  }

  setPeriode(value: Array<any>) {
    this.params.startDate = value[0]?.toISOString().slice(0, 10);
    this.params.endDate = value[1]?.toISOString().slice(0, 10);
    this.pagination.page = 1;
    this.getListCariSTT();
  }

  onSearch = debounce((value: string) => {
    if (value.length < 3 && value.length) return;
    this.params.search = value;
    this.pagination.page = 1;
    this.getListCariSTT();
  }, 250);

  async downloadManifest(id: any) {
    ListCariSTTController.getDownloadListCariSTT(id);
  }

  async mounted() {
    this.refs = this.$refs;
    await this.getListCariSTT();
  }

  refs = this.$refs as any;
  async printManifest(id: any) {
    // print pdf
    const data = await ListCariSTTController.getDetailSttScan(id);
    this.refs.print.printManifest(data);
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }
}
export default CariSTTList;
